// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__3m7cx","error":"Textarea_error__2G9F7","readonly":"Textarea_readonly__3sIYr","disabled":"Textarea_disabled__3pRHY"};